import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSingleNeutralActionsInformation = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M0.75 17.2501C0.75076 16.1342 1.02804 15.0359 1.55706 14.0533C2.08607 13.0708 2.85033 12.2347 3.78149 11.6197C4.71265 11.0047 5.7817 10.6301 6.89305 10.5293C8.00439 10.4285 9.12339 10.6047 10.15 11.0421"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M7.5 9C9.77817 9 11.625 7.15317 11.625 4.875C11.625 2.59683 9.77817 0.75 7.5 0.75C5.22183 0.75 3.375 2.59683 3.375 4.875C3.375 7.15317 5.22183 9 7.5 9Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M17.25 23.25C20.5637 23.25 23.25 20.5637 23.25 17.25C23.25 13.9363 20.5637 11.25 17.25 11.25C13.9363 11.25 11.25 13.9363 11.25 17.25C11.25 20.5637 13.9363 23.25 17.25 23.25Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M17.25 20.25V17.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "var(--icon-color, currentColor)",
			strokeWidth: 1.5,
			d: "M17.25 15C17.0429 15 16.875 14.8321 16.875 14.625C16.875 14.4179 17.0429 14.25 17.25 14.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "var(--icon-color, currentColor)",
			strokeWidth: 1.5,
			d: "M17.25 15C17.4571 15 17.625 14.8321 17.625 14.625C17.625 14.4179 17.4571 14.25 17.25 14.25"
		})
	]
});
export default SvgSingleNeutralActionsInformation;
